/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CityAndPrice
 */
export interface CityAndPrice {
    /**
     * 
     * @type {string}
     * @memberof CityAndPrice
     */
    city: string;
    /**
     * 
     * @type {number}
     * @memberof CityAndPrice
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof CityAndPrice
     */
    meanPrice: number;
    /**
     * 
     * @type {number}
     * @memberof CityAndPrice
     */
    price: number;
}

/**
 * Check if a given object implements the CityAndPrice interface.
 */
export function instanceOfCityAndPrice(value: object): value is CityAndPrice {
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('meanPrice' in value) || value['meanPrice'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function CityAndPriceFromJSON(json: any): CityAndPrice {
    return CityAndPriceFromJSONTyped(json, false);
}

export function CityAndPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CityAndPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'],
        'count': json['count'],
        'meanPrice': json['meanPrice'],
        'price': json['price'],
    };
}

export function CityAndPriceToJSON(value?: CityAndPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'city': value['city'],
        'count': value['count'],
        'meanPrice': value['meanPrice'],
        'price': value['price'],
    };
}

